import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recentPbxes: [],
  provisioningListCategoryCollapse: {},
  logs: {
    refreshInterval: 0,
    expand: false,
  },
  colorFilter: "default",
};

const { actions, reducer } = createSlice({
  name: "settings",
  initialState,
  reducers: {
    addPbxToRecents(state, action) {
      const pbx = action.payload;

      let recentsList = state.recentPbxes ?? [];

      const recentEntry = recentsList.find((_recent) => _recent.id === pbx.id) ?? {
        id: pbx.id,
        name: pbx.name,
        context: pbx.context,
        pinned: 0,
      };
      recentEntry.name = pbx.name;
      const lastPinnedItemIndex = recentsList.map((_recent) => _recent.pinned).lastIndexOf(1) + 1;

      // Validate if the new entry is a pinned item
      if (recentEntry.pinned !== 1) {
        recentsList = recentsList.filter((_recent) => pbx.id !== _recent.id);
        recentsList.splice(lastPinnedItemIndex === -1 ? 0 : lastPinnedItemIndex, 0, recentEntry);
      }

      state.recentPbxes = recentsList.slice(0, 12);
    },
    deletePbxFromRecents(state, action) {
      state.recentPbxes = state.recentPbxes.filter((pbx) => action.payload.id !== pbx.id);
    },
    togglePinStatePbxToRecents(state, action) {
      const pbx = action.payload;
      const recentsList = state.recentPbxes ?? [];

      const recentEntry = recentsList.find((_recent) => _recent.id === pbx.id) ?? {
        id: pbx.id,
        name: pbx.name,
        context: pbx.context,
        pinned: 0,
      };
      const lastPinnedItemIndex = recentsList.map((recents) => recents.pinned).lastIndexOf(1);

      // Remove the PBX from the recents
      const updateList = recentsList.filter((recents) => pbx.id !== recents.id);

      // Toggle the pinned state
      recentEntry.pinned = recentEntry.pinned === 0 ? 1 : 0;

      // Put the PBX back in the list at the back of the pinned entries
      updateList.splice(
        lastPinnedItemIndex === -1 ? 0 : recentEntry.pinned ? lastPinnedItemIndex + 1 : lastPinnedItemIndex,
        0,
        recentEntry,
      );

      state.recentPbxes = updateList;
    },
    clearRecentPbxes(state) {
      state.recentPbxes = [];
    },
    setProvisioningListCategoryCollapse(state, action) {
      state.provisioningListCategoryCollapse = action.payload;
    },
    // Log settings
    setLogRefreshInterval(state, action) {
      state.logs.refreshInterval = action.payload;
    },
    toggleLogExpand(state) {
      state.logs.expand = !state.logs.expand;
    },
    // Appearance settings
    setColorFilter(state, action) {
      state.colorFilter = action.payload;
    },
  },
});

export const {
  addPbxToRecents,
  deletePbxFromRecents,
  togglePinStatePbxToRecents,
  clearRecentPbxes,
  setProvisioningListCategoryCollapse,
  setLogRefreshInterval,
  toggleLogExpand,
  setColorFilter,
} = actions;

export default reducer;
